import React, { useEffect, useState } from 'react'
import Navbars from '../../common/Navbar'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import './index.css'
import { baseURL } from '../../api/api';

import NoImage from "../../assets/img/noimages.jpg";


function ProfileSettings() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);

  const [image,setImage] = useState("")

  const [showOld, setShowOld] = useState(false);
const [showNew, setShowNew] = useState(false);

const [showConfirm, setShowConfirm] = useState(false);

useEffect(()=>{
    fetchUserSetting()
},[])



  const [form, setForm] = useState({
    user_name: "",
    phone: "",
    old_password: "",
    password: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleBackCustomer = () => {
    navigate("/dashboard");
  };

  const profileCreate = async (e) => {
    e.preventDefault();
    setSubmit(true);
    setLoading(true);

    const apiData = {
      userData: {
        user_name: form.user_name,
        old_password: form.old_password,
        password: form.password,
        phone: form.phone
      }
    };

    try {
      const responseData = await superAdminApis.profileSettingUpdateAPI(apiData);

      if (responseData.apiStatus?.code === '200') {
        toast.success(responseData.apiStatus.message || 'Profile Updated!');
        navigate('/');
      } else {
        toast.error(responseData.apiStatus?.message || 'Update failed!');
      }
    } catch (error) {
      console.error('Error during update:', error);
      toast.error('An error occurred.');
    } finally {
      setLoading(false);
    }
  };


  
    const fetchUserSetting = async () => {
      try {
        const res = await superAdminApis.profileGetAPI();
        if (res?.apiStatus?.code === 200 || res?.apiStatus?.code === "200") {
         const data = res.result
         setImage(data?.profileImage)
           setForm({
    user_name: data.user_name || "",
    phone: data.phone || "",
    old_password: "",
    password: ""
  });
        } else {
          toast.error("Failed to fetch user");
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch user");
      }
    };

  return (
    <div>
      <Navbars />

      <div className="container all-modules-height card p-3">

        {/* Page Header */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
          <h5 className="heading-with-line mb-2 mb-md-0">
            Profile Settings
            <hr className="smooth-line" />
          </h5>

          <div className="d-flex gap-3">
            <button className="btn add-customer" onClick={handleBackCustomer}>
              <i className="fa fa-arrow-left me-2"></i> Back
            </button>
          </div>
        </div>

        {/* FORM */}
        <form data-aos="fade-up" autoComplete='off'>

          <div className="row p-0 overlay-text mt-3">
            <div className='col-md-2'>

  <div
  style={{
    width: "130px",
    height: "130px",
    borderRadius: "12px",
    overflow: "hidden",
    // boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f0f0f0"
  }}
>
  <img
src={image?.altered_file_name 
      ? baseURL + image.path + image.altered_file_name 
      : NoImage}
    alt="Customer"
    style={{
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain"  
    }}
  />
</div>

   
            </div>
            <div className='col-md-10'>
                <div className='row'>
    <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">User Name</label>
                <input
                  type="text"
                  name="user_name"
                  value={form.user_name}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Phone No</label>
                <input
                  type="number"
                   onWheel={(e) => e.preventDefault()} 
                  maxLength={12}
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

  <div className="col-md-6 mt-1">
  <div className="form-group">
    <label className="form-label">Old Password</label>

    <div className="password-wrapper-setting">
      <input
        type={showOld ? "text" : "password"}
        name="old_password"
        value={form.old_password}
        onChange={handleChange}
        className="form-control"
      />

      <i
        className={`fa ${showOld ? "fa-eye" : "fa-eye-slash"} toggle-eye`}
        onClick={() => setShowOld(!showOld)}
      ></i>
    </div>
  </div>
</div>


           <div className="col-md-6 mt-1">
  <div className="form-group ">
    <label className="form-label">New Password</label>
<div className='password-wrapper-setting'>
    <input
      type={showNew ? "text" : "password"}
      name="password"
      value={form.password}
      onChange={handleChange}
      className="form-control"
    />

    <i
      className={`fa ${showNew ? "fa-eye" : "fa-eye-slash"} toggle-eye`}
      onClick={() => setShowNew(!showNew)}
    ></i>
    </div>
  </div>
</div>


            <div className="text-end mt-3 text-center mb-3 all-btn-color">
              <button onClick={profileCreate} type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Updating..." : "Submit"}
              </button>
            </div>
                </div>
            </div>


        

          </div>

        </form>

      </div>
    </div>
  );
}

export default ProfileSettings;
